<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M16.1406 0.34375C15.0619 0.34375 14.1875 1.21819 14.1875 2.29688V18.7031C14.1875 19.7818 15.0619 20.6562 16.1406 20.6562H16.9219C18.0006 20.6562 18.875 19.7818 18.875 18.7031V2.29688C18.875 1.21819 18.0006 0.34375 16.9219 0.34375H16.1406Z"
				:fill="color" 
			/>
			<path
				d="M7.15625 6.98438C7.15625 5.90569 8.03069 5.03125 9.10938 5.03125H9.89062C10.9693 5.03125 11.8438 5.90569 11.8438 6.98438V18.7031C11.8438 19.7818 10.9693 20.6562 9.89062 20.6562H9.10938C8.03069 20.6562 7.15625 19.7818 7.15625 18.7031V6.98438Z"
				:fill="color" 
			/>
			<path
				d="M0.125 11.6719C0.125 10.5932 0.999444 9.71875 2.07812 9.71875H2.85938C3.93806 9.71875 4.8125 10.5932 4.8125 11.6719V18.7031C4.8125 19.7818 3.93806 20.6562 2.85938 20.6562H2.07812C0.999444 20.6562 0.125 19.7818 0.125 18.7031V11.6719Z"
				:fill="color" 
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgGraph',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	},
};
</script>

<style scoped>

</style>